import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  CircularProgress,
  Typography,
  Box,
  TablePagination,
  Grid,
  Stack,
} from "@mui/material";
import { motion } from "framer-motion";
import ClearIcon from "@mui/icons-material/Clear";
import { IconButton } from "@mui/material";
import check from "../../../Components/Assets/images/checkimg.jpg";
import wrong from "../../../Components/Assets/images/wrongimg.jpg";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
// import IconButton from "@mui/material/IconButton";
import Swal from "sweetalert2";
const CouponsTable = ({
  getwayData,
  loading,
  searchBy,
  search,
  page,
  perPage,
  total,
  setSearchBy,
  setSearch,
  setPage,
  setPerPage,
  handleEdit,
}) => {
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <motion.div
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <Grid
          container
          justifyContent="space-between"
          alignItems="center"
          spacing={2}
          sx={{ mb: 2 }}
        >
          <Grid item xs={12} md="auto">
            <Typography variant="h6">Total Geteways: {total}</Typography>
          </Grid>

          <Grid item xs={12} md={6}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <FormControl size="small" fullWidth>
                  <InputLabel>Search By</InputLabel>
                  <Select
                    value={searchBy}
                    onChange={(e) => setSearchBy(e.target.value)}
                    label="Search By"
                  >
                    <MenuItem value="getway_name">Getway Name</MenuItem>
                    {/* <MenuItem value="code">Code</MenuItem> */}
                    {/* <MenuItem value="discount_type">Type</MenuItem> */}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  size="small"
                  placeholder="Search"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  fullWidth
                  InputProps={{
                    endAdornment: search && (
                      <IconButton
                        size="small"
                        onClick={() => setSearch("")}
                        edge="end"
                      >
                        <ClearIcon fontSize="small" />
                      </IconButton>
                    ),
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </motion.div>

      <Box sx={{ display: { xs: "none", md: "block" } }}>
        {/* Your existing Paper with Table here */}
        <Paper elevation={3}>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow sx={{ backgroundColor: "#2196f3" }}>
                  {[
                    "S.No.",
                    "Gatway Name",
                    "Description",
                    "Api key",
                    "Api Secret",
                    "Status",
                    "Action",
                  ].map((header) => (
                    <TableCell
                      key={header}
                      sx={{ color: "white", fontWeight: "bold" }}
                    >
                      {header}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>

              <TableBody>
                {loading ? (
                  <TableRow>
                    <TableCell colSpan={11} align="center">
                      <CircularProgress />
                    </TableCell>
                  </TableRow>
                ) : getwayData.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={11} align="center">
                      <Typography variant="body2" sx={{ py: 2 }}>
                        No Getways found.
                      </Typography>
                    </TableCell>
                  </TableRow>
                ) : (
                  getwayData.map((getway, index) => (
                    <TableRow key={getway.id}>
                      <TableCell>{page * perPage + index + 1}</TableCell>
                      <TableCell>{getway.getway_name}</TableCell>
                      <TableCell>{getway.description}</TableCell>
                      <TableCell>{getway.api_key}</TableCell>
                      <TableCell>{getway.api_secret}</TableCell>
                      <TableCell align="center">
                        <img
                          src={getway.is_active ? check : wrong}
                          alt={getway.is_active ? "Active" : "Inactive"}
                          style={{ width: 24, height: 24 }}
                        />
                      </TableCell>
                      <TableCell>
                        <Stack direction="row" spacing={1}>
                          <IconButton
                            size="small"
                            onClick={() => handleEdit(getway)}
                          >
                            <EditIcon sx={{ color: "#1976d2" }} />
                          </IconButton>
                          {/* <IconButton
                          size="small"
                          // onClick={() => handleDelete(getway)}
                        >
                          <DeleteIcon sx={{ color: "red" }} />
                        </IconButton> */}
                        </Stack>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>

          <TablePagination
            rowsPerPageOptions={[10, 25, 50, 100]}
            component="div"
            count={total}
            rowsPerPage={perPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      </Box>
      <Box sx={{ display: { xs: "block", md: "none" } }}>
        {loading ? (
          <Box display="flex" justifyContent="center" py={4}>
            <CircularProgress />
          </Box>
        ) : getwayData.length === 0 ? (
          <Typography variant="body2" align="center" py={2}>
            No coupons found.
          </Typography>
        ) : (
          getwayData.map((getway, index) => (
            <Paper key={getway.id} elevation={2} sx={{ mb: 2, p: 2, mx: 1 }}>
              <Typography variant="subtitle1" fontWeight="bold">
                {page * perPage + index + 1}. {getway.getway_name}
              </Typography>
              <Typography variant="body2">Description: {getway.description}</Typography>
              <Typography variant="body2">
              Api Key  : ₹{getway.api_key}
              </Typography>
             
              <Typography variant="body2">
                Api Secret: {getway.api_secrete} / {getway.usage_limit ?? "∞"}
              </Typography>
              <Box mt={1} display="flex" alignItems="center">
                <img
                  src={getway.is_active ? check : wrong}
                  alt={getway.is_active ? "Active" : "Inactive"}
                  style={{ width: 24, height: 24 }}
                />
                {/* <Typography variant="body2">
                  {getway.is_active ? "Active" : "Inactive"}
                </Typography> */}
              </Box>
              <Stack direction="row" spacing={1} mt={1}>
                <IconButton size="small" onClick={() => handleEdit(getway)}>
                  <EditIcon sx={{ color: "#1976d2" }} />
                </IconButton>
                {/* <IconButton size="small" onClick={() => handleDelete(getway)}>
            <DeleteIcon sx={{ color: "red" }} />
          </IconButton> */}
              </Stack>
            </Paper>
          ))
        )}

        <TablePagination
          component="div"
          count={total}
          rowsPerPage={perPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Box>
    </Box>
  );
};

export default CouponsTable;
